import React from 'react';
import { useStopImpersonatingMutation } from '../api/authApiSlices';

const ImpersonationBanner = () => {
    const isImpersonating = localStorage.getItem("isImpersonating") === "true";
    const currentUser = JSON.parse(localStorage.getItem("user"));
    const originalUser = JSON.parse(localStorage.getItem("originalUser"));

    const [stopImpersonating] = useStopImpersonatingMutation();

    if (!isImpersonating) return null;

    const handleStopImpersonating = async () => {
        const token = JSON.parse(localStorage.getItem("token"));

        try {
            await stopImpersonating({ token }).unwrap();
        } catch (error) {
            console.error('Error stopping impersonation:', error);
        }

        // Restore original admin session
        const originalToken = localStorage.getItem("originalToken");
        localStorage.setItem("token", originalToken);
        localStorage.setItem("user", localStorage.getItem("originalUser"));

        // Clear impersonation data
        localStorage.removeItem("originalToken");
        localStorage.removeItem("originalUser");
        localStorage.removeItem("isImpersonating");

        // Reload page to apply restored session
        window.location.href = "/";
    };

    const bannerStyle = {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        background: 'linear-gradient(90deg, #f59e0b 0%, #d97706 100%)',
        color: '#000',
        padding: '10px 16px',
        textAlign: 'center',
        fontWeight: 600,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '16px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
    };

    const buttonStyle = {
        background: '#000',
        color: '#fff',
        border: 'none',
        padding: '6px 16px',
        borderRadius: '4px',
        cursor: 'pointer',
        fontWeight: 600,
        fontSize: '13px'
    };

    return (
        <div style={bannerStyle}>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
            <span>
                You are impersonating <strong>{currentUser?.first_name} {currentUser?.last_name}</strong>
                {originalUser && <span style={{ opacity: 0.8 }}> (Admin: {originalUser?.first_name} {originalUser?.last_name})</span>}
            </span>
            <button style={buttonStyle} onClick={handleStopImpersonating}>
                Stop Impersonating
            </button>
        </div>
    );
};

export default ImpersonationBanner;
